import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, DrawSVGPlugin);
// import Swiper from 'swiper/bundle';
// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import Swiper from 'swiper';

const gallerySlider = () => {
	const swiper = new Swiper('.swiper', {
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
		autoplay : {
			delay: 3000,
		},
		speed: 1000,
		spaceBetween: 20,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 640px
			640: {
				slidesPerView: 3,
				spaceBetween: 40
			}
		}
	});
};

const heroAnime = () => {
	var tl = gsap.timeline({
		repeat: 0
	});
	tl.from("#line_circle", {
		duration:2,
		stagger: 0.1,
		drawSVG: 0,
		ease: "power1.inOut"
	});
	tl.from("#map_miyazaki", {
		duration:2,
		opacity: 0,
		ease: "power1.inOut"
	}, "-=2");
	tl.from(".material", {
		opacity: 0,
		scale: 0,
		rotation: 180,
		transformOrigin:"50% 50%",
		duration:2,
		stagger: 0.1,
		ease: "power1.inOut"
	}, "-=2");
	tl.from(".logo_type", {
		opacity: 0,
		scale: 0,
		z: 100,
		// x: 100,
		// y: 100,
		transformOrigin:"50% 50%",
		duration: 1,
		stagger: 0.1,
		ease: "power1.inOut"
	}, "-=1");
};

const scrollAnime = () => {

	const tlScrollAnimeOne = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeOne",
			start: "-=5 top",
			end: "center center",
			markers: false
		}
	});
	tlScrollAnimeOne.to(".img_anime_1", {
		duration: 2,
		rotation: 20,
		yoyo: true,
		repeat: -1,
		transformOrigin:"50% 50%",
	});
	tlScrollAnimeOne.to(".img_anime_2", {
		duration: 2,
		rotation: -20,
		yoyo: true,
		repeat: -1,
		transformOrigin:"50% 50%",
	},"-=2");

	const tlScrollAnimeTwo = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeTwo",
			start: "-=400 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeTwo.from(".scroll_anime_2", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeThree = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeThree",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeThree.from(".scroll_anime_3", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeFour = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeFour",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeFour.from(".scroll_anime_4", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeFive = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeFive",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeFive.from(".scroll_anime_5", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeSix = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeSix",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeSix.from(".scroll_anime_6", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeSeven = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeSeven",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeSeven.from(".scroll_anime_7", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	const tlScrollAnimeEight = gsap.timeline({
		scrollTrigger: {
			trigger: "#scrollAnimeEight",
			start: "-=200 center",
			end: "bottom bottom",
			markers: false
		}
	});
	tlScrollAnimeEight.from(".scroll_anime_8", {
		duration: 1,
		opacity: 0,
		scale: 0.25,
		// y: -100,
		transformOrigin:"50% 50%",
	});

	// const boxes = gsap.utils.toArray('.scroll_anime_3');
	// boxes.forEach(box => {
	// 	gsap.from(box, {
	// 		duration: 1,
	// 		opacity: 0,
	// 		scale: 0.25,
	// 		y: -100,
	// 		transformOrigin:"50% 50%",
	// 		scrollTrigger: {
	// 			trigger: box,
	// 			scrub: true
	// 		}
	// 	})
	// });
}

window.addEventListener('load', () => {
	gallerySlider();
	heroAnime();
	scrollAnime();
});


